import Application from './application';
import { trackEvent } from './utilities/index';

let Results = function (params) {
  // console.log('Results initalizing ' + params);

  /**
   *
   */
  let self = this;
  let ResultsElement = document.getElementById( 'results' );
  let background = ResultsElement.querySelector('.bg-image' );
  let header = ResultsElement.querySelector('.header' );
  let primaryTitle = ResultsElement.querySelector('h2.primary' );
  let alternateTitle = ResultsElement.querySelector('h2.alternate' );

  let leftCol = ResultsElement.querySelector('.learn-more');
  let rightCol = ResultsElement.querySelector('.club-photo');
  let exploreButton = ResultsElement.querySelector('.explore-button');
  let exploreTS1Button = ResultsElement.querySelector('.explore-ts1');
  let exploreTSI2Button = ResultsElement.querySelector('.explore-tsi2');
  let exploreTSI3Button = ResultsElement.querySelector('.explore-tsi3');
  let exploreTS4Button = ResultsElement.querySelector('.explore-ts4');
  let fittingButton = ResultsElement.querySelector('.fitting-button');
  let homeButton = ResultsElement.querySelector('.home-button');
  let showAlternateButton = ResultsElement.querySelector('.alternate-button');
  let showPrimaryButton = ResultsElement.querySelector('.primary-button');
  let timeline;
  let nextPage = "primary";
  let driverId = "";

  this.open = function(fadeBG) {
    if (fadeBG === null || fadeBG === undefined) {
      fadeBG = true;
    }
    // console.log('Results.open');
    this.setResults();
    TweenLite.set( [header, leftCol, rightCol], {opacity: 0});
    ResultsElement.style.display = 'block';
    timeline = new TimelineLite({onComplete: this.openComplete, onCompleteScope: this});
    if (fadeBG === true) {
      TweenLite.set( [background], {opacity: 0});
      timeline.to(background, Application.tweenLength, {opacity: 1});
      timeline.to(header, Application.tweenLength, {opacity: 1}, Application.tweenStagger);
    } else {
      timeline.to(header, Application.tweenLength, {opacity: 1});
    }
    timeline.to(leftCol, Application.tweenLength, {opacity: 1}, Application.tweenStagger);
    timeline.to(rightCol, Application.tweenLength, {opacity: 1}, Application.tweenStagger);
    timeline.play();
  };

  this.setResults = function() {
    // ironId = window.ironSelector.calculateResults();
    let sortedScores = window.driverSelector.calculateResults();
    if (nextPage === "alternate") {
      driverId = sortedScores[1];
      // toggle buttons
      showPrimaryButton.style.display = 'inline-block';
      showAlternateButton.style.display = 'none';
      alternateTitle.style.display = 'block';
      primaryTitle.style.display = 'none';
    } else {
      driverId = sortedScores[0];
      // toggle buttons
      showPrimaryButton.style.display = 'none';
      showAlternateButton.style.display = 'inline-block';
      alternateTitle.style.display = 'none';
      primaryTitle.style.display = 'block';
    }
    exploreTS1Button.style.display = 'none';
    exploreTSI2Button.style.display = 'none';
    exploreTSI3Button.style.display = 'none';
    exploreTS4Button.style.display = 'none';
    ResultsElement.querySelector('.explore-' + driverId).style.display = 'inline-block';
    console.log('selected driver id is: ' + driverId);
    ResultsElement.classList.add('show-' + driverId);
    nextPage = "";

    // track here or in the application?
     trackEvent('Recommendation', 'Primary', sortedScores[0]);
     trackEvent('Recommendation', 'Alternative', sortedScores[1]);
  };

  this.openComplete = function () {
    console.log('openComplete');
    // // todo: initialize controls
    homeButton.addEventListener('click', this.homeClicked);
    showAlternateButton.addEventListener('click', this.alternateClicked);
    showPrimaryButton.addEventListener('click', this.primaryClicked);
    // tracking listners
    exploreButton.addEventListener('click', this.exploreClicked);
    fittingButton.addEventListener('click', this.fittingClicked);
  };

  this.exploreClicked = function(event) {
    trackEvent('navigation', 'Results', 'Product Details');
  };

  this.fittingClicked = function(event) {
    trackEvent('navigation', 'Results', 'Find A Fitting Location');
  };



  this.homeClicked = function(event) {
    let override = homeButton.getAttribute('data-url-override');
    if (override === null || override === undefined || override === "") {
      nextPage = "home";
      self.close();
      trackEvent('navigation', 'Home');
    } else {
      parent.window.location.href = override;
      // window.location.href = override;
    }
  };
  // this.homeClicked = function(event) {
  //   nextPage = "home";
  //   self.close();
  //   trackEvent('navigation', 'Home');
  // };


  this.alternateClicked = function(event) {
    nextPage = "alternate";
    self.close();
    trackEvent('navigation', 'Results', 'See alternate Results');
  };

  this.primaryClicked = function(event) {
    nextPage = "primary";
    self.close();
    trackEvent('navigation', 'Results', 'See Primary Results');
  };

  this.disableControls = function () {
    // console.log('disable controls ' + homeButton);
    // // todo: initialize controls
    homeButton.removeEventListener('click', this.homeClicked);
    showAlternateButton.removeEventListener('click', this.alternateClicked);
    showPrimaryButton.removeEventListener('click', this.primaryClicked);
    // tracking listners
    exploreButton.removeEventListener('click', this.exploreClicked);
    fittingButton.removeEventListener('click', this.fittingClicked);
  };

  this.close = function () {
    console.log('close ' + nextPage);
    this.disableControls();
    timeline.kill();
    timeline = new TimelineLite({onComplete: closeComplete});
    timeline.to(leftCol, Application.tweenLength, {opacity: 0});
    timeline.to(rightCol, Application.tweenLength, {opacity: 0}, Application.tweenStagger);
    timeline.to(header, Application.tweenLength, {opacity: 0}, Application.tweenStagger);
    if (nextPage === 'home') {
      timeline.to(background, Application.tweenLength, {opacity: 0}, Application.tweenStagger);
    }
    timeline.play();

  };

  function closeComplete() {
    // console.log('closeComplete ' + nextPage);
    timeline.kill();
    timeline = null;
    ResultsElement.style.display = 'none';
    ResultsElement.classList.remove('show-' + driverId);
    if (nextPage === "home") {
      // console.log('reset');
      nextPage = "primary";
      window.driverSelector.reset();
    } else if (nextPage === "primary") {
      console.log('primary');
      self.open(false);
    } else if (nextPage === "alternate") {
      console.log('alternate');
      self.open(false);
    }
  }

};

export default Results;

